import {Component, inject, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild} from '@angular/core';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {Splash} from '../../../../../Akte/Controlls/Splash';
import {FormsModule} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {DataGridView, DataGridViewCollumn, Types} from '../../../../../Componente/DataGridView';
import {StatusModel} from '../../../../../Api/DcoApi/Status/StatusModel';
import {AktePopup} from '../../../Status/AktePopup';
import {Lauf} from '../../../../../Api/DcoApi/Abrechnung/Lauf';

@Component({
  selector: 'app-missing-inbetriebnahme-liste',
  imports: [
    CommonModule,
    Splash,
    FormsModule,
    DataGridView,
    DataGridViewCollumn
  ],
  standalone: true,
  templateUrl: './missing-inbetriebnahme-liste.html',
  styleUrl: './missing-inbetriebnahme-liste.css',
})
export class MissingInbetriebnahmeListe implements OnChanges, OnInit{
  @Input() Akten: number[] = [];
  modal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);
  @ViewChild('Grid') childComponent!: DataGridView<any>;

  Url= signal<string>("");

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["Akten"]) {
      this.SetUrl();
    }
  }

  ngOnInit(): void {
    this.SetUrl();
  }

  SetUrl()
  {
    this.Url.set(`/AbrechnungData/InfoList?${this.Akten.map(o => `ids=${o}`).join("&")}`);
  }

  protected readonly Types = Types;

  OpenAkte(row: any) {
    var modal = this.modalService.open(AktePopup)
    modal.componentInstance.Key = row.key;
    modal.componentInstance.versichertenNr = row.versichertennumer;
    modal.closed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.childComponent.LoadData();
      },
      error: (err) => {
        this.childComponent.LoadData();
      },
    });
  }
}
